<template>
  <div>
    <titleBox name="旷真债务重组" imgUrl="../../assets/zhichanBg.jpg"></titleBox>
    <!-- 旷真债务重组 -->
    <div
      class="itemBox"
      style="
        background-image: url(https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/debtRestructuring-01-BG.png);
      "
      id="yewu"
    >
      <h2 class="titleBox">
        <img
          src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/01.png"
          class="numberImg"
          alt=""
        />
        旷真债务重组
        <i class="redIcon"></i>
      </h2>
      <p class="contenMsg">
        近年来，受国内外经济下行叠加企业经营管理不当影响，众多企业生存面临前所未有的挑战，陷入资金短缺或资不抵债的困境。破产法律制度的广泛实施，给此类困境企业通过司法程序实现破茧重生，或市场出清提供了路径选择和制度保障。
      </p>
      <p class="contenMsg mt-2">  
        旷真债务重组融合资深律师、注册会计师、投资顾问等行业精英，专为央企、国企、民企、上市公司、中小企业等各类型企业提供债务重组、预重整、破产重整、和解、破产清算以及强制清算服务。
      </p>
    </div>
    <!-- 服务产品 -->
    <div class="itemBox" id="yewu">
      <h2 class="titleBox">
        <img
          src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/02.png"
          class="numberImg"
          alt=""
        />
        服务产品<span class="redColor"></span>
        <i class="redIcon"></i>
      </h2>
      <div class="fwcp-content">
        <div v-for="(fwcpItem, fwcpIndex) in fwcpList" class="fwcp-item">
          <h3 class="littleTitle">
            <div>{{fwcpItem.name}}</div>
            <div class="littleTitle-bottom">
              <div></div>
            </div>
          </h3>
          <div class="fwcp-item-content">
            <div v-for="(fwcpData, fwcpDataIndex) in fwcpItem.data"
              class="fwcp-item-data"
              :style="fwcpDataIndex==5 ? 'background: #fff;' : ''">
              <div class="content" v-if="fwcpData.title">
                <img
                  src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/debtRestructuring/debtRestructuring-02-01.png"
                  alt=""
                />
                <div>{{fwcpData.title}}</div>
              </div>
              <div
                v-if="fwcpData.list"
                class="fwcp-item-data-content">
                <div v-for="childItem in fwcpData.list" class="fwcpChild-item">
                  <div class="dot">•</div>
                  <div class="fwcpChild-item-content">{{childItem}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 服务特色 -->
    <div class="itemBox" id="tese">
      <h2 class="titleBox">
        <img
          src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/03.png"
          class="numberImg"
          alt=""
        />
        服务特色<span class="redColor"></span>
        <i class="redIcon"></i>
      </h2>
      <div class="set-main-three">
        <div v-for="(item, index) in fwtsList">
          <div class="set-three-item">
            <div class="set-three-item-left">
              <img
                class="set-three-item-left-img1"
                :src="item.img"
                alt=""
                :style="index==1 ? 'width: 0.6rem; left: 0.2rem' : ''"
              />
              <img
                class="set-three-item-left-img2"
                src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/debtRestructuring/debtRestructuring-03-01.png"
                alt=""
              />
            </div>
            <div class="set-three-item-right">
              <div class="set-three-item-right-title">
                <span class="set-three-item-right-name">{{item.title}}</span>
              </div>
              <div class="set-three-item-right-content">{{item.content}}</div>
            </div>
          </div>
          <div>
            <div class="set-three-item-footer" v-if="index+1 != fwtsList.length"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 服务优势 -->
    <div
      class="itemBox"
      style="
        background-image: url(https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/debtRestructuring-04-BG.png);
      "
      id="tese">
      <h2 class="titleBox">
        <img
          src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/04.png"
          class="numberImg"
          alt=""
        />
        服务优势<span class="redColor"></span>
        <i class="redIcon"></i>
      </h2>
      <div class="set-main-four">
        <template v-for="(item, index) in fwysList">
          <div class="set-four-item">
            <div class="set-four-item-left">
              <div class="set-four-item-left-id">{{item.id}}</div>
              <img
                src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/debtRestructuring/debtRestructuring-04-01.png"
                alt=""
              />
            </div>
            <div class="set-four-item-right">
              <div class="set-four-item-right-title">
                <span class="set-four-item-right-name">{{item.title}}</span>
              </div>
              <div class="set-four-item-right-content">{{item.content}}</div>
            </div>
          </div>
        </template>
      </div>
    </div>

  </div>
</template>

<script>
import titleBox from "../../components/titleBox/index";
export default {
  components: { titleBox },
  data() {
    return {
      fwcpList: [
        {
          name: "庭外重组顾问服务",
          data: [
            {
              title: "债务重组服务",
              list: [
                "拟定减债方案",
                "参与债权人谈判"
              ]
            }, {
              title: "风险控制体系搭建",
              list: [
                "实控人法律风险分析",
                "实现债务风险隔离"
              ]
            }, {
              title: "财税法务咨询服务",
              list: [
                "财务咨询及税务筹划",
                "对接审计机构"
              ]
            }, {
              title: "合同梳理与权益维护",
              list: [
                "梳理重大合同",
                "维护合同利益最大化"
              ]
            }, {
              title: "衍生诉讼代理服务",
              list: [
                "更优质的诉讼代理",
                "提前介入债权债务处理"
              ]
            }, {
              title: "",
              list: []
            }
          ]
        }, {
          name: "预重整/破产重整顾问服务",
          data: [
            {
              title: "预重整/破产重整受理前辅导咨询",
              list: [
                "全面梳理资产负债",
                "对接财务审计",
                "实控人法律风险分析",
                "准备申请材料",
                "参加听证等"
              ]
            }, {
              title: "预重整/破产重整期间顾问服务",
              list: [
                "对接利益相关方",
                "协助申请自行管理",
                "解答程序中的相关问题",
                "实控人股权保护",
                "协助制作预重整/重整计划草案",
                "促成预重整/重整计划表决通过"
              ]
            }, {
              title: "重整计划执行阶段服务",
              list: [
                "协助计划执行",
                "执行不能时提出调整方案",
                "重整未果的处理方案"
              ]
            }
          ]
        }
      ],
      fwtsList: [
        {
          img: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/debtRestructuring/debtRestructuring-03-02.png",
          title: "提供整体解决方案",
          content: "区别于个案诉讼代理，本服务在对企业进行全面债权债务梳理的基础上制定整体解决方案，解决企业系统性风险问题。"
        }, {
          img: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/debtRestructuring/debtRestructuring-03-03.png",
          title: "提供定制化服务",
          content: "结合不同行业企业特点及其面临的不同困境情况、个性化需求，制定符合企业需求且具有实操性的解决方案。"
        }, {
          img: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/debtRestructuring/debtRestructuring-03-04.png",
          title: "提供全方位一站式资源对接",
          content: "依托旷真汇集的各行业企业资源、各领域人才资源，对债务重组涉及的相关第三方均可提供资源对接，实现资源整合。"
        }, {
          img: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/debtRestructuring/debtRestructuring-03-05.png",
          title: "实现企业与个人风险隔离",
          content: "帮助企业主全面分析相关法律风险，通过风险控制体系搭建，实现企业与个人之间的风险隔离。"
        }
      ],
      fwysList: [
        {
          id: "01",
          title: "多地法院管理人资质",
          content: "已被深圳、重庆、长沙、珠海法院纳入管理人名册，其他地区持续申请加入管理人名册。"
        }, {
          id: "02",
          title: "资深破产重整律师团队",
          content: "专注深耕破产重整业务、企业债务重组10余年"
        }, {
          id: "03",
          title: "化债经验丰富",
          content: "重整、化债涉及地域广泛、行业多样，化解各类企业问题经验丰富"
        }, {
          id: "04",
          title: "对接投资人资源",
          content: "投资人、投资人资源平台推荐"
        }
      ]
    };
  },
  methods: {
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.redColor {
  color: #ab0000;
}
.arrowIcon {
  position: relative;
  font-size: 0.1rem;
  top: -0.15rem;
  color: #fa6e23;
}
.itemBox {
  // width: 95%;
  margin: 0rem auto;
  padding: 0 0 0.5rem 0;
  background-color: #fff;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .titleBox {
    width: 95%;
    margin: auto;
    padding-top: 0.5rem;
    margin-bottom: 0.2rem;
    position: relative;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.5rem;

    .numberImg {
      position: relative;
      top: 0.05rem;
      width: 0.5rem;
      height: 0.5rem;
    }
  }
  .contenMsg {
    width: 87%;
    margin: 0 auto;
    box-sizing: border-box;
    padding-left: 0.2rem;
    line-height: 0.6rem;
    font-size: 0.35rem;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #666666;
  }
  .littleTitle {
    font-size: 0.4rem;
    text-align: center;
    color: #333333;
    img {
      width: 60%;
    }
    .littleTitle-bottom {
      display: flex;
      justify-content: center;
      margin-top: 0.2rem;
      div {
        width: 1.2rem;
        height: 0.1rem;
        background: #C8050F;
      }
    }
    // line-height: 1rem;
  }
  .mt-2 {
    margin-top: 0.2rem;
  }
  .fwcp-content {
    width: 95%;
    margin: 0.7rem auto;
    .fwcp-item {
      .fwcp-item-content {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        .fwcp-item-data {
          width: 31%;
          background: #F9F9F9;
          .content {
            display: flex;
            background: #AB0000;
            padding: 0.2rem 0.1rem;
            img {
              width: 0.28rem;
              height: 0.32rem;
              margin-right: 0.05rem;
            }
            div {
              color: #fff;
              font-size: 0.3rem;
              font-weight: bold;
              line-height: 0.36rem;
            }
          }
          .fwcp-item-data-content {
            padding: 0.2rem 0.1rem;
            .fwcpChild-item {
              display: flex;
              line-height: 0.5rem;
              .dot {
                color: #AB0000;
                padding-right: 0.05rem;
              }
              .fwcpChild-item-content {
                font-size: 0.3rem;
              }
            }
          }
        }
        .fwcp-item-data:nth-child(4), .fwcp-item-data:nth-child(5), .fwcp-item-data:nth-child(6) {
          margin-top: 0.4rem;
        }
      }
    }
  }
  .set-main-three {
    width: 95%;
    margin: 0.7rem auto;
    .set-three-item {
      display: flex;
      margin: 0.25rem 0;
      .set-three-item-left {
        position: relative;
        margin-right: 0.3rem;
        padding-top: 0.3rem;
        .set-three-item-left-img1 {
          position: absolute;
          width: 0.45rem;
          top: 0.52rem;
          left: 0.3rem;
        }
        .set-three-item-left-img2 {
          width: 1rem;
        }
      }
      .set-three-item-right {
        .set-three-item-right-title {
          .set-three-item-right-name {
            font-size: 0.35rem;
            color: #AB0000;
            font-weight: bold;
            line-height: 0.6rem;
          }
        }
        .set-three-item-right-content {
          font-size: 0.28rem;
          color: #4C4C4C;
          line-height: 0.42rem;
        }
      }
    }
    .set-three-item-footer {
      background: repeating-linear-gradient(to right, #CCCCCC, #CCCCCC 0.05rem, transparent 0.05rem, transparent 0.1rem);
      height: 0.05rem; /* 设置元素高度 */
      width: 100%; /* 设置元素宽度为100% */
    }
  }
  .set-main-four {
    width: 95%;
    margin: 0.7rem auto;
    margin-bottom: 1.2rem;
    .set-four-item {
      display: flex;
      margin-bottom: 0.4rem;
      .set-four-item-left {
        position: relative;
        display: flex;
        .set-four-item-left-id {
          color: #fff;
          font-weight: bold;
          position: absolute;
          font-size: 0.6rem;
          z-index: 2;
          align-self: center;
          left: 0.15rem;
        }
        img {
          width: 1rem;
          position: absolute;
          align-self: center;
        }
      }
      .set-four-item-right {
        background: #fff;
        width: 100%;
        padding: 0.3rem 0.8rem;
        margin-left: 0.5rem;
        .set-four-item-right-title {
          .set-four-item-right-name {
            font-size: 0.35rem;
            color: #AB0000;
            font-weight: bold;
            line-height: 0.6rem;
          }
        }
        .set-four-item-right-content {
          font-size: 0.28rem;
          color: #4C4C4C;
          line-height: 0.42rem;
        }
      }
    }
  }
}
.redIcon {
  position: relative;
  display: inline-block;
  top: -0.25rem;
  width: 10px;
  height: 7px;
  background-size: 100% 100%;
  background-image: url(http://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/redIcon.png);
}
</style>
